import React, { useEffect } from 'react';
import {
  NUMBER,
  minimumMessageText,
  maximumMessageText,
} from '../Utility/TypeValues';
import { useDispatch } from 'react-redux';
import { setErrorMessage } from 'src/Actions/ErrorActions';

const ValidateComponent = (props) => {
  const dispatch = useDispatch();

  const { questionContent } = props.question;
  let errorMessage = questionContent;
  const { answer } = props;
  if (
    props.question.type === NUMBER &&
    (answer.error === minimumMessageText || answer.error === maximumMessageText)
  ) {
    errorMessage = props.question.numericQuestionContent;
  }

  useEffect(() => {
    // set store for error message
    if (errorMessage && answer.error !== '') {
      dispatch(setErrorMessage(errorMessage[answer.error]));
    }
  }, [errorMessage, answer.error, dispatch]);

  return questionContent && answer.error !== '' ? (
    <div className="error_message " style={{ display: 'none' }}>
      {errorMessage[answer.error]}
    </div>
  ) : (
    ''
  );
};

export default ValidateComponent;
